export default "__VITE_ASSET__CTHbTPtB__"